export default __webpack_public_path__ + "static/media/filled_pin.e1707984.svg";